import { createFileRoute } from '@tanstack/react-router';

import { AccessLogTable } from 'component/partial/tables/logs/AccessLog/AccessLogTable';

export const Route = createFileRoute('/n/_auth/sites/$siteId/_details/logs/access-log')({
  component: AccessLogRoute,
});

function AccessLogRoute() {
  return <AccessLogTable />;
}
